import Swiper from 'swiper/bundle';

export function initSwiperGallery (query = document.querySelectorAll('.gallery.swiper')) {
    for (const gallerySlider of query) {
        new Swiper(gallerySlider, {
            slidesPerView: 3,
            spaceBetween: 12,
            autoHeight: false,
            autoplay: true,
            loop: false,
            speed: 200,
            on: {
                slideChangeTransitionStart(swiper) {
                    const wrapper = swiper.wrapperEl;
                    wrapper.style.transitionTimingFunction = 'cubic-bezier(0.2, 1.2, 0.4, 1)';
                    wrapper.style.transitionDuration = '600ms';
                },
                slideChangeTransitionEnd(swiper) {
                    const wrapper = swiper.wrapperEl;
                    wrapper.style.transitionTimingFunction = '';
                    wrapper.style.transitionDuration = '';
                },
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.75
                },
                768: {
                    slidesPerView: 3
                }
            },
        });

        const main = gallerySlider.closest('main');
        const directChild = Array.from(main.children).find(child => child.contains(gallerySlider));
        const nextSibling = directChild?.nextElementSibling;

        if (nextSibling) {
            const existingPaddingTop = parseFloat(getComputedStyle(nextSibling).paddingTop) || 0;

            const updateLayout = () => {
                const halfHeight = gallerySlider.offsetHeight / 2;
                nextSibling.style.marginTop = `-${halfHeight}px`;
                nextSibling.style.paddingTop = `${existingPaddingTop + halfHeight}px`;
            };

            updateLayout();
            new ResizeObserver(updateLayout).observe(gallerySlider);
        }
    }
}